// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"1531b04a","116":"2734da25","129":"b164063e","295":"b3798b27","306":"65e2ca4d","400":"3badd282","629":"7d3ff321","762":"10e5867c","797":"a059bd5b","840":"a3e1c475","927":"29a90d46","966":"c4a94696"}[chunkId] + ".chunk.css";
};